import { getAuth, signOut } from 'firebase/auth';
import serverErrorHandler from 'services/serverError.service';
import useUserStore from 'store/useUserStore';
import { clearPostLoginRedirect } from 'utils/postLoginRedirect';

// handles user logout
export default function useLogout() {
  const logout = async () => {
    try {
      const auth = getAuth();
      await signOut(auth);
      clearPostLoginRedirect();
      useUserStore.getState().logout();
    } catch (e) {
      serverErrorHandler(e);
    }
  };
  return { logout };
}
